<template>
  <div class="medication-wrap">
    <div class="med-box">
      <van-cell-group class="name">
        <van-cell
          title="作物名称"
          is-link
          :value="cropNameValue"
          @click="showPicker = true"
          :class="{ black: cropNameValue != '请选择' }"
        />
        <van-popup v-model="showPicker" position="bottom" get-container="body">
          <van-picker
            show-toolbar
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
      </van-cell-group>
      <van-cell-group class="address">
        <van-cell
          title="作业地址"
          is-link
          value="请添加"
          @click="goToAddress"
          v-if="addressList.length == 0"
        />
      </van-cell-group>
      <ul class="ads-ul">
        <li
          v-for="(item, index) in addressList"
          :key="index"
          class="van-hairline--top-bottom"
          @click="gotoDetailAddress(item, index)"
        >
          <van-icon name="location-o" class="loca-icon" />
          <div class="title">作业地址{{ index + 1 }}</div>
          <div class="address">
            {{ item.address }}{{ item.detailAddress }} {{ item.cropNumber }}亩
          </div>
          <van-icon name="arrow" class="arrow-icon" />
        </li>
        <div
          class="add"
          v-if="addressList.length >= 1 && addressList.length < 3"
          @click="goToAddress"
        >
          <van-icon name="plus" />
        </div>
      </ul>
      <van-cell-group class="three">
        <van-cell
          :title="`作物亩数(最少${mini_mu}亩)`"
          :value="crops == 0 ? '' : crops"
          :class="{ black: crops != 0 }"
        />
        <van-cell
          title="用药"
          is-link
          class="use-goods black"
          :value="durg_ids.name + durg_group_id.name || '不带药'"
          @click="goToChooseMed"
          label="提醒：禁止使用入水溶解或崩解差的（可湿性）粉剂及水分散粒剂产品。"
        />
        <!--  :class="{'black':durg_group_id.name || durg_ids.name}" -->
        <van-cell
          title="开始日期"
          is-link
          :value="chooseData || '请选择'"
          @click="openPick"
          :class="{ black: chooseData != '' }"
        />
        <van-popup v-model="showDatePicker" position="bottom" get-container="body">
          <van-datetime-picker
            v-model="currentDate"
            type="datetime"
            :min-date="minDate"
            :max-date="maxDate"
            :title="weatherTitle"
            @confirm="getTime"
            @cancel="closeDate"
            @change="getWeatherData"
            :formatter="formatter"
            :filter="filter"
          />
        </van-popup>
      </van-cell-group>
      <van-cell-group class="cell-price">
        <van-cell title="作物单价" :value="unitPrice ? '¥' + unitPrice : ''" class="farm-price" />
        <van-cell title="总价" :value="totalPrice" class="farm-price text" />
      </van-cell-group>
      <van-field
        v-model="message"
        class="message"
        rows="3"
        autosize
        label="备注"
        type="textarea"
        maxlength="200"
        placeholder="请填写"
        show-word-limit
      />
    </div>
    <div class="tips">
      提醒：田间有较多障碍物（电线杆、高压线等）、临近禁飞区（机场、边境、监狱等）不适合飞防作业；田间地块很分散、不同地块的转场距离远可能导致飞手二次议价。
    </div>
    <div class="price-bar">
      <div
        class="price"
        :class="{
          success:
            chooseData &&
            (durg_ids.name || durg_group_id.name) &&
            cropNameValue != '请选择' &&
            addressList,
        }"
      >
        预付款：¥{{ totalPrice }}
      </div>
      <div
        class="btn"
        :class="{
          success: chooseData && cropNameValue != '请选择' && addressList && crops >= mini_mu,
        }"
        ref="askBtn"
        @click="askFly"
      >
        呼叫飞防
      </div>
    </div>
    <Pay
      @clickPayOne="fly"
      ref="pays"
      :money="totalPrice"
      :directPay="true"
      :order="order_sn"
    ></Pay>
  </div>
</template>
<script>
// import CropName from "../../components/cropName/cropName";
import axios from '../../http';
import { mapState } from 'vuex';
import Pay from '../../components/pay/pay';

export default {
  name: 'medication',
  components: { Pay },
  props: {},
  data() {
    return {
      message: '',
      cropsArray: [], //作物的数据
      cropNameValue: '请选择', //选择的作物
      unitPrice: 0, //选择了的作物单价
      // totalPrice: 0, //总价
      columns: [],
      showPicker: false, //作物
      showDatePicker: false,
      // minDate: new Date(),
      maxDate: new Date(2050, 1, 1),
      currentDate: new Date(),
      chooseData: '', //选择的日期
      start_date: '', //发送数据用的日期
      weatherArray: [],
      weatherTitle: '当日  天气预报获取中...',
      order_sn: '',
      documentHeight: document.documentElement.clientHeight,
      isShowFlag: true,
    };
  },
  computed: {
    ...mapState(['addressList', 'durg_ids', 'durg_group_id', 'user_region_id', 'token']),
    minDate() {
      let date = new Date();
      let hour = date.getHours();
      let m = date.getMinutes();
      if (m >= 1) {
        let t = new Date().getTime() + 3600000;
        let d = new Date(t);
        if (hour >= 19) {
          // return new Date(new Date().getDate() + 1)
        }
        return d;
      }
    },
    mini_mu() {
      // 最低亩数
      let mu = 0;
      this.cropsArray.forEach((el) => {
        if (el.name == this.cropNameValue) {
          mu = el.min_mu;
        }
      });
      return mu;
    },
    crop_id() {
      //选择的作物id
      let id = '';
      this.cropsArray.forEach((el) => {
        if (el.name == this.cropNameValue) {
          id = el.id;
        }
      });
      return id;
    },
    //作业地址
    crops() {
      //作业亩数计算
      let result = 0;
      this.addressList.forEach((item) => {
        result += parseFloat(item.cropNumber);
      });
      return result;
    },
    totalPrice() {
      //总价
      let price = parseFloat(this.unitPrice) * parseFloat(this.crops);
      return parseFloat(price.toFixed(2));
    },
    address_ids() {
      //作业地址 ","链接
      let ids = [];
      this.addressList.forEach((el) => {
        ids.push(el.id);
      });
      return ids.join(',');
    },
    address_nums() {
      //作业亩数 ","链接
      let ids = [];
      this.addressList.forEach((el) => {
        ids.push(el.cropNumber);
      });
      return ids.join(',');
    },
  },
  watch: {
    user_region_id(newVal) {
      this.getWeather();
    },
    cropNameValue() {
      //作物单价
      this.cropsArray.forEach((el) => {
        if (el.name == this.cropNameValue) {
          this.unitPrice = `${el.value}`;
        }
      });
    },
  },
  mounted() {
    this.getCrops();
    this.getWeather();
    window.onresize = () => {
      return (() => {
        if (this.documentHeight > document.documentElement.clientHeight) {
          this.isShowFlag = false;
        } else {
          this.isShowFlag = true;
        }
      })();
    };
  },
  destroyed() {},
  methods: {
    formatter(type, val) {
      //时间格式 格式化
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      } else if (type === 'hour') {
        return `${val}时`;
      }
    },
    filter(type, options) {
      // 过滤时间
      if (type === 'hour') {
        return options.filter((option) => {
          return option >= 8 && option <= 18;
        });
      }
      return options;
    },
    getCrops() {
      //获取作物种类
      axios
        .fetchGet('/api/type/crops')
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.cropsArray = data.data;
            data.data.forEach((item) => {
              this.columns.push(item.name);
            });
          }
        })
        .catch((error) => {
          console.log('error:', error);
        });
    },
    getWeather() {
      axios
        .fetchPost('/api/order/weather_all', {
          token: this.token,
          region_id: this.user_region_id,
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.weatherArray = data.data;
          } else {
            this.weatherTitle = data.msg;
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    onConfirm(value) {
      // 选择作物
      this.cropNameValue = value;
      this.showPicker = false;
    },
    goToAddress() {
      //选择作物地址
      this.$router.push({
        path: '/workAddress',
      });
    },
    goToChooseMed() {
      //选择带药
      if (this.addressList.length == 0) {
        this.$toast('请先添加作业地址');
        return;
      }
      this.$router.push({
        path: '/chooseMed',
      });
    },
    openPick() {
      //打开时间选择pick
      if (this.addressList.length == 0) {
        this.$toast('请先添加作业地址');
        return;
      }
      this.showDatePicker = true;
      this.weatherTitle = this.weatherArray[0].weather;
      // this.getWeather();
    },

    gotoDetailAddress(data, index) {
      //路由-地址详情
      data.dindex = index;
      let afterData = data;
      console.log('afterData :>> ', afterData);
      this.$router.push({
        path: '/addressDetail',
        query: { data: afterData },
      });
    },
    getTime(value) {
      // 点击确定获取时间
      let Month = value.getMonth() + 1;
      if (Month < 10) {
        Month = '0' + Month;
      }
      let getDate = value.getDate();
      if (getDate < 10) {
        getDate = '0' + getDate;
      }
      let hours = value.getHours();
      if (hours < 10) {
        hours = '0' + value.getHours();
      }
      let getMinutes = value.getMinutes();
      if (getMinutes < 10) {
        getMinutes = '0' + getMinutes;
      }
      let getSeconds = value.getSeconds();
      if (getSeconds < 10) {
        getSeconds = '0' + getSeconds;
      }
      let st = value.getFullYear() + '-' + Month + '-' + getDate + '  ' + hours + ':00';

      this.start_date = st;
      console.log('st :>> ', st);
      this.showDatePicker = false;
      this.chooseData = st;
    },
    closeDate() {
      this.showDatePicker = false;
    },
    getWeatherData(picker) {
      let p = picker.getValues();
      let date = p[0].slice(0, -1) + '-' + p[1].slice(0, -1) + '-' + p[2].slice(0, -1);

      for (let i = 0; i < this.weatherArray.length; i++) {
        if (this.weatherArray[i].date == date) {
          this.weatherTitle = this.weatherArray[i].weather;
          break;
          return;
        }
        this.weatherTitle = '时间跨度太大，无法获取当日天气';
      }
    },
    fly() {
      //呼叫飞防订单形成
      axios
        .fetchPost('/api/order/call', {
          token: this.token,
          crop_id: this.crop_id,
          address_ids: this.address_ids,
          mus: this.address_nums,
          start_date: this.start_date,
          durg_ids: this.durg_group_id.id,
          durg_group_id: this.durg_ids.id,
          remark: this.message,
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.order_sn = data.data.order_sn;
            this.$refs.pays.show = true;
            //去支付了
          }
          this.$toast(data.msg);
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    askFly() {
      //飞防下单
      if (this.crops < this.mini_mu) {
        this.$toast('总亩数不能少于最低亩数！');
        return;
      }
      let claName = this.$refs.askBtn.className;
      if (claName == 'btn') {
        this.$toast('请填写全部数据，在提交订单');
        return;
      }
      // 发送呼呼打药请求
      this.fly();
    },
  },
};
</script>
<style lang="stylus" scoped>
.medication-wrap
  text-align left
  padding-bottom 50px
  background #efefef
  .med-box
    .name
      margin-top 10px
    .address
      margin-top 10px
    .three
      margin-top 10px
      .use-goods
        /deep/.van-cell__label
          color #FF9922
        /deep/.van-cell__value
          width 50px
    .cell-price
      padding-top 10px
      background #efefef
      .farm-price
        .van-cell__value
          color #FF9922
    .message
      margin-top 10px
      /deep/.van-field__body
        max-height 160px
        overflow auto
      /deep/.van-field__label
        width 40px
    .van-icon
      line-height 24px
  .tips
    color #FF9922
    font-size 12px
    padding 10px 14px
    line-height 20px
  .price-bar
    height 50px
    line-height 50px
    position fixed
    left 0
    right 0
    display flex
    bottom 0
    background #fff
    .price
      flex 1
      text-align right
      padding-right 15px
      font-size 16px
      font-family Microsoft YaHei
      font-weight 400
      color rgba(152, 152, 152, 1)
      &.success
        color #FF9922
    .btn
      width 115px
      text-align center
      background #989898
      font-size 17px
      &.success
        background #FF9922
        color #fff
  .ads-ul
    margin-top 10px
    padding-left 13px
    background #fff
    & > li
      padding 31px 61px 10px 23px
      position relative
      .arrow-icon
        position absolute
        right 13px
        top 15px
        font-size 13px
        color #BEBEBE
      .title
        font-size 14px
        font-family Microsoft YaHei
        font-weight 400
        color #282828
        position absolute
        top 10px
        left 0
      .loca-icon
        position absolute
        left 0
        top 38px
        font-size 15px
        color #656565
      .address
        font-size 14px
        color #282828
        line-height 20px
    .add
      height 50px
      line-height 50px
      text-align center
      font-size 18px
      color #989898
      margin-left -13px
      & > i
        line-height 50px
/deep/.van-picker__title
  flex 1
  max-width 90%
  font-size 12px
.black
  .van-cell__value
    span
      color #282828
</style>
